import { updateRestaurantTheme } from "../../api/restaurantApi";

export const ThemeTypes = {
  LIGHT: "LIGHT",
  DARK: "DARK",
  CUSTOM: "CUSTOM",
};

export const LightModeTheme = {
  themeType: ThemeTypes.LIGHT,
  themeString: JSON.stringify({
    menuBackground: "#ffffff",
    menuPageBackground: "#f9b09b",
    menuTextColor: "#000000",
    menuHeaderTextColor: "#000000",
    menuHeaderColor: "#f2f2f7",
    sidenavColor: "#f9b09b",
    sidenavTextColor: "#ffffff",
    sidenavHoverColor: "#f9b09b",
  }),
};

export const DarkModeTheme = {
  themeType: ThemeTypes.DARK,
  themeString: JSON.stringify({
    menuBackground: "#1e1e1e",
    menuPageBackground: "#121212",
    menuTextColor: "#ffffff",
    menuHeaderTextColor: "#ffffff",
    menuHeaderColor: "#403e3e",
    sidenavColor: "#333333",
    sidenavTextColor: "#ffffff",
    sidenavHoverColor: "#444444",
    profileBackground: "#1e1e1e",
  }),
};

export const onThemeChange = (theme) => {
  if (theme.themeType === ThemeTypes.LIGHT) {
    theme = LightModeTheme;
  } else if (theme.themeType === ThemeTypes.DARK) {
    theme = DarkModeTheme;
  }
  const themeData = JSON.parse(theme.themeString);
  const root = document.documentElement;
  root.style.setProperty("--menu-background", themeData.menuBackground);
  root.style.setProperty("--menu-text-color", themeData.menuTextColor);
  root.style.setProperty(
    "--menu-page-background",
    themeData.menuPageBackground,
  );
  root.style.setProperty(
    "--menu-header-text-color",
    themeData.menuHeaderTextColor,
  );
  root.style.setProperty("--menu-header-color", themeData.menuHeaderColor);
  root.style.setProperty("--sidenav-color", themeData.sideNavText);
  root.style.setProperty("--sidenav-color", themeData.sidenavColor);
  root.style.setProperty("--sidenav-text-color", themeData.sidenavTextColor);
  root.style.setProperty("--sidenav-hover-color", themeData.sidenavHoverColor);
  root.style.setProperty("--profile-background", themeData.profileBackground);

  const restaurant = JSON.parse(localStorage.getItem("restaurant"));
  const restaurantId = restaurant?.id;

  if (restaurantId) {
    // Update the restaurant in local storage and the database
    localStorage.setItem(
      "restaurant",
      JSON.stringify({ ...restaurant, theme: theme }),
    );
    updateRestaurantTheme(restaurantId, theme);
  } else {
    console.warn("No restaurant ID found. Theme update skipped.");
  }
};
